import { SearchState } from './state'

export const Types = {
  UPDATE_SEARCH_CONDITIONS: 'search/update_search_conditions',
  INITIALIZE_FETCH_MASTER_DATA: 'search/initialize_fetch_master_data',
  CACHE_SEARCH_MASTER_DATA: 'search/cache_search_master_data',
  LOAD_CONDITIONS: 'search/load_conditions',
  SAVE_CONDITIONS: 'search/save_conditions',
}

export const updateSearchConditions = (
  payload: Partial<SearchState['conditions']>
) => ({
  type: Types.UPDATE_SEARCH_CONDITIONS,
  payload,
})

export const initializeFetchMasterData = () => ({
  type: Types.INITIALIZE_FETCH_MASTER_DATA,
})

export const cacheSearchMasterData = (payload: {
  activities: SearchState['activities']
  areas: SearchState['areasByPref']
}) => ({
  type: Types.CACHE_SEARCH_MASTER_DATA,
  payload,
})

export const loadConditions = () => ({ type: Types.LOAD_CONDITIONS })

export const saveConditions = () => ({ type: Types.SAVE_CONDITIONS })
